// src/utils/claimAttention.js
//
// Lo que necesita atención en una lista de reclamos: decisiones pendientes
// del PA y plazos que vencen. Lo usan la lista de reclamos (ClaimsDirectory)
// y el inicio del ajustador (AdjusterHome), así ambos cuentan lo mismo.
import { claimStepLabel, getStep } from '../services/flowService';
import { getStepTimer } from '../config/flowRules';
import { FINAL_STEPS } from '../config/claimFlow';

const checkLabel = (check, language) => `${language === 'es' ? 'Cheque' : 'Check'}${check.checkNumber ? ` #${check.checkNumber}` : ''} · ${getStep('check', check.flow.stepId)?.label[language === 'es' ? 'es' : 'en'] || ''}`;

// Reclamos cuyo paso actual es una decisión del PA (autorizar reporte,
// envío del estimado, ruta…), más los cheques de la Fase 4 cuyo paso es del
// PA (ruta de endoso, depósito, breakdown, desembolso). El más antiguo primero.
export const awaitingPaItems = (claimRecords = [], checks = [], language = 'es') => [
  ...claimRecords
    .filter(cr => cr.flow?.actor === 'pa' && !FINAL_STEPS.includes(cr.flow.stepId))
    .map(cr => ({ key: `claim-${cr.id}`, claimRecordId: cr.id, claimNumber: cr.claimNumber, clientName: cr.clientName, adjusterName: cr.adjusterName, flow: cr.flow, what: claimStepLabel(cr, language) })),
  ...checks
    .filter(check => check.flow?.actor === 'pa' && check.flow.phase === 'A' && check.claimRecordId)
    .map(check => ({
      key: `check-${check.id}`, claimRecordId: check.claimRecordId, claimNumber: check.claimNumber, clientName: check.clientName, adjusterName: check.adjusterName, flow: check.flow,
      what: checkLabel(check, language)
    }))
].sort((a, b) => (a.flow.enteredAt?.toMillis?.() || 0) - (b.flow.enteredAt?.toMillis?.() || 0));

// Plazos del documento del cliente que vencen o ya vencieron (LOR 72 h,
// FA 48 h, llegada del cheque). El que vence antes primero.
export const deadlineItems = (claimRecords = [], checks = [], language = 'es') => {
  const urgent = timer => timer && (timer.status === 'overdue' || timer.status === 'warning');
  const list = [];
  claimRecords.forEach(cr => {
    const timer = getStepTimer('claim', cr);
    if (urgent(timer)) list.push({ key: `claim-${cr.id}`, claimRecordId: cr.id, name: cr.clientName, number: cr.claimNumber, what: claimStepLabel(cr, language), timer });
  });
  checks.forEach(check => {
    const timer = check.flow?.stepId ? getStepTimer('check', check) : null;
    if (!urgent(timer) || !check.claimRecordId) return;
    list.push({ key: `check-${check.id}`, claimRecordId: check.claimRecordId, name: check.clientName, number: check.claimNumber, what: checkLabel(check, language), timer });
  });
  return list.sort((a, b) => a.timer.dueAt - b.timer.dueAt);
};

// Días completos en el paso actual (null si el paso no tiene fecha de entrada).
export const daysInStep = (item, now = Date.now()) => {
  const ms = item?.flow?.enteredAt?.toMillis?.();
  return ms ? Math.max(0, Math.floor((now - ms) / 86400000)) : null;
};
